var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _path8, _g6, _path9, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNamibia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_27630",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4849 0.402344H0.921875V19.9803H34.4849V0.402344Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_27630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.921875 0.402344V19.9814L34.4839 0.402344H0.921875Z",
    fill: "#1F357E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_27630",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4849 0.402344H0.921875V19.9803H34.4849V0.402344Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_27630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4839 0.402344L0.921875 19.9814H34.4839V0.402344Z",
    fill: "#3D9546"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_27630",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4849 0.402344H0.921875V19.9803H34.4849V0.402344Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_27630)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_27630",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4849 0.402344H0.921875V19.9803H34.4849V0.402344Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_27630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.68005 22.9926L-0.835938 16.9696L32.7271 -2.6084L36.2421 3.41864L2.68005 22.9926Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_27630",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4849 0.402344H0.921875V19.9803H34.4849V0.402344Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_27630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2395 22.2424L-0.396484 17.7194L33.1635 -1.85156L35.8045 2.6604L2.2395 22.2424Z",
    fill: "#C0003B"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_27630",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4849 0.402344H0.921875V19.9803H34.4849V0.402344Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_27630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8302 7.42236L9.39117 7.17639L9.63721 8.61334L8.51416 7.68036L8.00616 9.05139L7.49817 7.68036L6.37317 8.61334L6.62115 7.17639L5.18018 7.42236L6.11316 6.29736L4.74219 5.78937L6.11316 5.27734L5.18018 4.15234L6.62115 4.40637L6.37317 2.96539L7.49817 3.89838L8.00616 2.52734L8.51416 3.89838L9.63721 2.96539L9.39117 4.40637L10.8302 4.15234L9.89618 5.27734L11.2692 5.78937L9.89618 6.29736L10.8302 7.42236Z",
    fill: "#F5CD28"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_27630",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4849 0.402344H0.921875V19.9803H34.4849V0.402344Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_27630)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_27630",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4849 0.402344H0.921875V19.9803H34.4849V0.402344Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_27630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96289 5.78906C9.96289 6.87106 9.08586 7.74603 8.00586 7.74603C6.92386 7.74603 6.04688 6.87106 6.04688 5.78906C6.04688 4.70706 6.92386 3.83203 8.00586 3.83203C9.08586 3.83203 9.96289 4.70706 9.96289 5.78906Z",
    fill: "#1F357E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_27630",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4849 0.402344H0.921875V19.9803H34.4849V0.402344Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_27630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.63708 5.78937C9.63708 6.69137 8.90704 7.42236 8.00604 7.42236C7.10404 7.42236 6.37305 6.69237 6.37305 5.78937C6.37305 4.88737 7.10404 4.15234 8.00604 4.15234C8.90604 4.15234 9.63708 4.88737 9.63708 5.78937Z",
    fill: "#F5CD28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamibia);
export default __webpack_public_path__ + "static/media/NAMIBIA.25c901efcbce7eed2eda03eb276f51b1.svg";
export { ForwardRef as ReactComponent };